module.exports = __webpack_public_path__ + "static/media/3.Complete Range of Bath fittings.ad1b02b9.jpg";